'use strict';

const { h } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');
const DateTime = require('@grpn/preact-l10n/datetime');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const MerchantFilter = require('./merchant-filter');
const CouponsList = require('../../coupons/views/coupons-list-filter');
const RichContent = require('../../coupons/views/rich-content');
const MerchantExpiredOffers = require('./merchant-offers-table');
const SidebarBrowseLetter = require('./sidebar-browse-letter');
const SidebarBrowseMerchant = require('./sidebar-browse-merchant');
const Carousel = require('../../shared/views/carousel');
const MerchantOfferCount = require('./merchant-offer-count');
const EmailSubscription = require('../../email_subscription/views/email-subscription');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');
const getUniqueArrayFromObjects = require('../../support/get-unique-array-from-objects');

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-sidebar',
    coupons,
    autoplay: true,
    navigation: false,
    options: {
      perPage: 1,
    },
  };
}

function MerchantMain({ payload, params, deps }) {
  const {
    keyAuthData,
    seoMetaData: { h1Override },
    navigationMerchants,
    merchantDetails,
    merchantMeta,
    couponsForList,
    topMerchantsList,
    similarMerchants,
    directRedemption,
    advertsForCarousel,
  } = payload;
  const { routes, csrfToken } = deps;

  const offerTypes = getUniqueArrayFromObjects(
    couponsForList,
    c => c.offerType
  );

  return h('article', [
    h(RedemptionProvider, { routes, directRedemption }),
    h('section.container.merchant', [
      h(Header, {
        routes,
        keyAuthData,
        merchants: navigationMerchants,
        tag: 'span',
      }),
      h('.merchant-layout', [
        h('.merchant-sidebar', [
          h('.merchant-section.merchant-section-logo', [
            h(WithI18n, {}, i18n =>
              h(
                '.merchant-logo',
                MerchantLogoImage({
                  className: 'merchant-logo-image',
                  data: merchantDetails.merchantMedia,
                  size: ['w_220,h_220'],
                  lazyload: false,
                  alt: i18n.t('js.modules.shared.LogoAltTextFormat', {
                    0: merchantDetails.merchantName,
                  }),
                })
              )
            ),
            h(
              'a.merchant-outlink',
              {
                href: routes.redirect.merchant.replace(
                  '{merchantId}',
                  merchantDetails.merchantId
                ),
                target: '_blank',
                rel: 'noopener nofollow',
                'data-bhw': `store:${params.merchantSlug}`,
              },
              merchantDetails.merchantWebsiteName
            ),
          ]),
          h('.merchant-section.merchant-section-total', [
            h('.merchant-total', [
              couponsForList.length,
              h(
                Translate,
                {
                  attrs: { class: 'merchant-total-text' },
                },
                'modules.widget.CodesAvailable'
              ),
            ]),
          ]),
          offerTypes.length > 1 &&
            h('fieldset.merchant-section', [
              h(
                Translate,
                {
                  tag: 'legend',
                  attrs: { class: 'merchant-heading merchant-heading-filter' },
                },
                'modules.shared.OfferFilter'
              ),
              h(MerchantFilter, { coupons: couponsForList }),
            ]),
        ]),
        h('.merchant-meta', [
          merchantDetails.description &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h2',
                  attrs: { class: 'merchant-heading' },
                  0: merchantDetails.merchantName,
                },
                'modules.merchant.AboutMerchantHeadingFormat'
              ),
              h('span.merchant-text', merchantDetails.description),
            ]),
          EmailSubscription({
            csrfToken,
            routes,
            className: 'merchant-section',
            bhwName: `MerchantEmailSubscription:${params.merchantSlug}`,
          }),
          merchantMeta.didYouKnow &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantDetails.merchantName,
                },
                'modules.merchant.DidYouKnowHeadingFormat'
              ),
              merchantMeta.didYouKnow,
            ]),
          merchantMeta.sitePicks &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantDetails.merchantName,
                },
                'modules.merchant.SitePicksHeadingFormat'
              ),
              h('.merchant-text', {
                dangerouslySetInnerHTML: { __html: merchantMeta.sitePicks },
              }),
            ]),
          h('.merchant-section', [
            h(
              Translate,
              {
                tag: 'h3',
                attrs: { class: 'merchant-heading' },
              },
              'modules.merchant.OfferCountsTableHeading'
            ),
            h(MerchantOfferCount, { coupons: couponsForList }),
          ]),
          advertsForCarousel &&
            advertsForCarousel.length > 0 &&
            h(
              '.merchant-section.carousel-container',
              Carousel({ routes, ...getCarouselOptions(advertsForCarousel) })
            ),
          h('.merchant-section', h(SidebarBrowseLetter, { routes })),
          h(SidebarBrowseMerchant, {
            routes,
            className: '.merchant-section',
            merchants: topMerchantsList,
            localisation: {
              resource: 'modules.shared.TopBrands',
              data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
            },
            bloodhound: 'SideBarPopularStores',
          }),
          similarMerchants.length > 0 &&
            h(SidebarBrowseMerchant, {
              routes,
              className: '.merchant-section',
              merchants: similarMerchants,
              localisation: {
                resource: 'modules.merchant.SimilarBrandsFormat',
                data: {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantDetails.merchantName,
                },
              },
              bloodhound: 'SideBarRelatedBrands',
            }),
        ]),
        h(
          'h1.merchant-title',
          h('.merchant-title-text', [
            h1Override ||
              h(
                Translate,
                {
                  0: merchantDetails.merchantName,
                  1: h(DateTime, {
                    value: Date.now(),
                    format: 'MMMM YYYY',
                  }),
                },
                'modules.merchant.OffersPageHeadingFormat'
              ),
            h('span.merchant-title-total', [
              couponsForList.length,
              h(
                Translate,
                { attrs: { class: 'merchant-title-total-text' } },
                'modules.widget.CodesAvailable'
              ),
            ]),
          ])
        ),
        h('.merchant-content', [
          h(
            '.merchant-section',
            {
              'data-bhw': `MerchantCouponsList:${params.merchantSlug}`,
            },
            h(CouponsList, {
              routes,
              coupons: couponsForList,
              media: 'callout',
              color: merchantDetails.calloutColour,
            })
          ),
          h('.merchant-section', [
            h(
              Translate,
              {
                tag: 'h2',
                attrs: { class: 'merchant-heading' },
                0: merchantDetails.merchantName,
              },
              'modules.merchant.ExpiredOffersHeading'
            ),
            MerchantExpiredOffers({ offers: couponsForList }),
          ]),
        ]),
        h('.merchant-seotext', [
          h(RichContent, { data: merchantMeta.richContent }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = MerchantMain;
